import {
    faBus,
    faTrain,
    faPlane,
    faBedFront,
    faPuzzlePiece,
    faQuestion,
    faSparkles,
} from '@fortawesome/pro-regular-svg-icons';
import { type ChooseBillOptionInfo, type QuestionData } from '../support.type';
import { Question } from './Question';

export class BillQuestion extends Question {
    readonly billInfo?: ChooseBillOptionInfo;
    constructor(question: QuestionData) {
        super(question);
        this.billInfo = question.chooseBillOptionInfo;
    }

    get serviceInfo() {
        const uniqueTypes = new Set(
            this.billInfo?.reserveTypes?.filter(
                reserveType => reserveType !== 'SuggestedService'
            )
        );
        if (uniqueTypes.size > 1) {
            return {
                title: 'ترکیبی',
                icon: faSparkles,
            };
        }
        switch (this.billInfo?.reserveTypes?.[0]) {
            case 'Bus':
                return {
                    title: 'اتوبوس',
                    icon: faBus,
                };
            case 'Train':
                return {
                    title: 'قطار',
                    icon: faTrain,
                };
            case 'Flight':
                return {
                    title: 'هواپیما',
                    icon: faPlane,
                };
            case 'Hotel':
                return {
                    title: 'هتل',
                    icon: faBedFront,
                };
            case 'SuggestedService':
                return {
                    title: 'خدمات جانبی',
                    icon: faPuzzlePiece,
                };
            default:
                return {
                    title: 'نامشخص',
                    icon: faQuestion,
                };
        }
    }

    get statusInfo() {
        switch (this.billInfo?.billStatus) {
            case 'Finalized':
                return {
                    color: 'green',
                    text: 'صادر شده',
                };
            case 'UnsuccessfulBuy':
                return {
                    color: 'red',
                    text: 'خرید ناموفق',
                };
            case 'Canceled':
                return {
                    color: 'yellow',
                    text: 'کنسل شده',
                };
            case 'Pending':
                return {
                    color: 'blue',
                    text: 'در حال صدور',
                };
            case 'MultiTickets':
                return {
                    color: 'blue',
                    text: 'چند بلیط',
                };
            default:
                return {
                    color: 'gray',
                    text: 'نامشخص',
                };
        }
    }
}
